import React from 'react';

export interface CpsTabItem {
  id: string;
  title: string;
}

export interface CpsTabsProps {
  items: CpsTabItem[];
  selected: number;
  onSelect: (selected: number) => void;
  ariaLabel?: string;
  className?: string;
  children?: React.ReactNode;
}

export const CpsTabs: React.FC<CpsTabsProps> = ({
  items,
  selected,
  onSelect,
  ariaLabel,
  className,
  children
}) => {
  const selectedIndex = selected >= 0 && selected < items.length ? selected : 0;

  return (
    <div className={`cpsTabs${className ? ` ${className}` : ''}`}>
      <nav className="cpsTabsNav" aria-label={ariaLabel}>
        <ul className="cpsTabsList">
          {items.map((item, index) => {
            const isSelected = selectedIndex === index;

            return (
              <li key={item.id}>
                <button
                  type="button"
                  className={`cpsTabsTab${isSelected ? ' cpsTabsTab--active' : ''}`}
                  aria-selected={isSelected}
                  onClick={() => onSelect(index)}
                >
                  {item.title}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
      {children !== undefined && children !== null ? <div className="cpsTabsContent">{children}</div> : null}
    </div>
  );
};
